<template>
    <main class="c-app-content is-sidebar-tiny">
        <div class="row">
            <div class="col-12">
                <div class="card title">
                    <div class="card-body title-filter">
                        <div class="row">
                            <div class="col-lg-3 title-filte-left">
                                <h1 v-if="!id" class="title-filter-title">
                                    <i class="b-table-icon fa fa-plus-circle"></i>
                                    <p class="pl-1">Thêm bài viết</p>
                                </h1>
                                <h1 v-if="id" class="title-filter-title">
                                    <i class="b-table-icon fa fa-edit"></i>
                                    <p class="pl-1">Chỉnh sửa bài viết</p>
                                </h1>
                            </div>
                            <div class="col-lg-9 title-filte-right"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <g-loading v-if="firstLoading" />
        <div class="row" v-else >
            <div class="col-9">
                <div class="card">
                    <div class="card-body">
                        <form-input  :required='true'  label="Tiêu đề bài viết" :model="formModel" :errors="formErrors" attribute="title" placeholder="Nhập tiêu đề của bài viết"/>
                        <form-input label="Đường dẫn" :required='true' :model="formModel" attribute="slug" :errors="formErrors" desc="Chuỗi cho đường dẫn tĩnh là phiên bản của tên hợp chuẩn với Đường dẫn (URL). Chuỗi này bao gồm chữ cái thường, số và dấu gạch ngang (-)." />
                        <form-textarea  :required='true'  label="Mô tả ngắn" :model="formModel" :errors="formErrors" attribute="excerpt" desc="Mô tả ngắn là một đoạn mô tả về nội dung mà bạn tự nhập bằng tay, có thể được sử dụng để hiển thị trong giao diện của bạn" />
                        <form-editor  :required='true'  label="Nội dung bài viết" :model="formModel" :errors="formErrors" attribute="content" />
                    </div>
                </div>
                <div class="card" v-if="1!=1">
                    <div class="card-header">
                        <h3 class="card-title font-weight-bold">Thông tin khác</h3>
                    </div>
                    <div class="card-body">
                        <form-radio-group @change="typeChange()" class='checkbox-label-bold' label="Đối tượng đăng bài" :model="formModel" attribute="type" :options="$params.post.typeOptions" :errors="formErrors" />
                        <div class="row">
                            <div v-if="formModel.type == 'cn'" class="col-md">
                                <form-input    label="Họ và tên" :model="formModel" :errors="formErrors" attribute="fullname"/>
                            </div>
                            <div class="col-md">
                                <form-input  label="Tên tổ chức" :model="formModel" :errors="formErrors" attribute="site_name"/>
                            </div>
                            <div class="col-md">
                                <form-input  label="Địa chỉ liên hệ tổ chức" :model="formModel" :errors="formErrors" attribute="site_address"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title font-weight-bold">Thẻ</h3>
                    </div>
                    <div class="card-body pt-3 pb-0">
                        <keyword :model="formModel" attribute="keywords" :errors="formErrors" :multiple="true" :filter="{type: '1'}" />
                    </div>
                </div>

                <form-files label="Tài liệu đính kèm" :model="formModel" :errors="formErrors" attribute="files" />

                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title font-weight-bold">Ảnh quảng cáo</h3>
                    </div>
                    <div class="card-body pt-3 pb-0">
                        <div class="row">
                            <div class="col-md-6">
                                <form-media :model="formModel" attribute="ads_img_one" :errors="formErrors" desc="Kích thước tiêu chuẩn (380x210)" accept="image/jpeg,image/png,image/jpg" />
                            </div>
                            <div class="col-md-6">
                                <form-media :model="formModel" attribute="ads_img_two" :errors="formErrors" desc="Kích thước tiêu chuẩn (380x210)" accept="image/jpeg,image/png,image/jpg" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <form-input  label="Link đính kèm quảng cáo 1" :model="formModel" :errors="formErrors" attribute="link_ads_one"/>
                            </div>
                            <div class="col-md-6">
                                <form-input  label="Link đính kèm quảng cáo 2" :model="formModel" :errors="formErrors" attribute="link_ads_two"/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-3">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title font-weight-bold">Chuyên mục</h3>
                    </div>
                    <div class="card-body pt-2 pb-0">
                        <category :model="formModel" attribute="categories" :errors="formErrors" />
                    </div>
                    <div v-if="formModel.categories == 2" class="card-body pt-2 pb-0">
                        <form-radio-group  class='checkbox-label-bold' label="Nhóm" :model="formModel" attribute="group" :options="$params.post.groupOptions" :errors="formErrors" />
                    </div>
                </div>
                
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title font-weight-bold">Đăng bài</h3>
                    </div>
                    <div class="card-body pt-2 pb-0">
                        <form-input   :required='false'    label="Tác giả" :model="formModel" :errors="formErrors" attribute="author"/>
                        <form-input   :required='false'    label="Nguồn" :model="formModel" :errors="formErrors" attribute="source"/>
                        <form-checkbox  class='checkbox-label-bold' chkLabel="Tin nổi bật" :model="formModel" attribute="highlight" :errors="formErrors" />
                        <form-checkbox  class='checkbox-label-bold' chkLabel="Ẩn hiển thị mô tả ngắn" :model="formModel" attribute="hide_excerpt" :errors="formErrors" />
                        <form-radio-group  class='checkbox-label-bold' label="Ngôn ngữ" :model="formModel" attribute="lang" :options="$params.post.langOptions" :errors="formErrors" />
                        <form-radio-group :disabled='true' v-if="!permissions('post_approved')"  class='checkbox-label-bold' label="Trạng thái bài" :model="formModel" attribute="status" :options="$params.post.statusOptions" :errors="formErrors" />
                        <form-radio-group v-if="!(!permissions('post_approved'))" class='checkbox-label-bold' label="Trạng thái bài" :model="formModel" attribute="status" :options="$params.post.statusOptions" :errors="formErrors" />
                        </div>
                        <div class="card-footer text-right"> 
                            <b-button v-if="!formModel.id || !(!permissions('post_approved') && formModel.status != 'private')" :disabled="saveLoading" variant="primary" class="float-right" @click="save">
                                <b-spinner v-if="saveLoading" small></b-spinner>
                                <em v-else class="fa fa-save" ></em>
                                {{permissions('post_approved') && formModel.status != 'private' ? 'Đăng bài' : 'Lưu lại'}}
                            </b-button>
                            <b-button v-if="!permissions('post_approved') && formModel.status != 'private'" :disabled="saveLoading" variant="primary" class="float-right" @click="openIndex()">
                                <b-spinner v-if="saveLoading" small></b-spinner>
                                <em v-else class="fa fa-save" ></em>
                                Lưu lại
                            </b-button>
                            <b-button style="margin-right: 4px;" :disabled="saveLoading" variant="secondary" class="float-right" @click="openPreview();">
                                <b-spinner v-if="saveLoading" small></b-spinner>
                                <em v-else class="fa fa-eye"></em>
                                Xem trước
                            </b-button>
                            <b-button style="margin-right: 4px;" :disabled="saveLoading" variant="secondary" class="float-right" onclick="window.location.href = '#/post/index';">
                                <b-spinner v-if="saveLoading" small></b-spinner>
                                <em v-else></em>
                                Đóng
                            </b-button>
                        </div>
                        </div>
                               
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title font-weight-bold">Ảnh đại diện <span class="text-danger">*</span></h3>
                                    </div>
                                    <div class="card-body p-3">
                                        <form-media :model="formModel" attribute="thumbnail" :errors="formErrors" desc="Kích thước tiêu chuẩn (380x210)" accept="image/jpeg,image/png,image/jpg" />
                                    </div>
                                </div>
                                </div>
                                </div>
                                <b-modal  v-model="showFormView" size="md" title="Xem trước bài viết" cancel-title="Huỷ" no-close-on-backdrop no-enforce-focus>
                                    <div class="col-md-12">
                                        <img width="100%" v-if="formModel.thumbnail && files[formModel.thumbnail]" :src="files[formModel.thumbnail]" class="img" alt="Bài viết" />
                                        <h1 v-if="formModel.title">{{formModel.title}}</h1>
                                        <div class="user">
                                            <p v-if="formModel.created_time">Ngày đăng {{formModel.created_time * 1000 | datetimeFormat}} <span style="width: 200px;">{{ formModel.author }}</span></p> 
                                        </div>
                                        <b v-if="formModel.excerpt">{{formModel.excerpt }}</b>
                                        <form-textarea v-if="formModel.content" :required='false' :model="formModel" :errors="formErrors" v-html="formModel.content" attribute="content" desc="" />
                                    </div>
                                    <template v-slot:modal-footer="{ cancel }">
                                        <b-button variant="secondary" class="float-right" @click="cancel">Đóng</b-button>
                                    </template>
                                </b-modal>
                                </main>
                                </template>

                                <script>
                                    import crud from '@/mixins/CRUD';
                                    import FormMedia from '@/components/media/FormMedia';
                                    import FormFiles from './FormFiles';
                                    import Keyword from '@/components/KeywordSelect';
                                    import Category from '@/components/PostCategoryTreeSelect';
                                    import role from '@/mixins/Role';

                                    export default {
                                        props: ['id'],
                                        components: {Keyword, Category, FormMedia, FormFiles},
                                        mixins: [crud, role],
                                        data: function () {
                                            return {
                                                firstLoading: true,
                                                service: '/post',
                                                defaultFormModel: {
                                                    title: null,
                                                    slug: null,
                                                    page: "main",
                                                    format: 'content',
                                                    status: 'private',
                                                    comment_status: 'public',
                                                    lang: 'vi',
                                                    thumbnail: null,
                                                    files: [],
                                                    keywords: [],
                                                    categories: [],
                                                    type: 'cn',
                                                    template: null,
                                                    highlight: 0,
                                                    hide_excerpt: 0,
                                                    author: this.$store.state.user.name,
                                                    group: 1
                                                },
                                                showFormView: false,
                                                files: {},
                                            };
                                        },
                                        watch: {
                                            "id": {
                                                handler(val) {
                                                    if (!val) {
                                                        this.formModel = Object.assign({}, this.defaultFormModel);
                                                        this.formErrors = {};
                                                        this.firstLoading = false;
                                                    }
                                                }, deep: true
                                            },
                                            "formModel.title": {
                                                handler(val) {
                                                    if (val && (!this.formModel.id || !this.formModel.slug)) {
                                                        this.formModel.slug = this.$utils.createCode(val);
                                                    }
                                                }, deep: true
                                            },
                                            "formModel.slug": {
                                                handler(val) {
                                                    if (val) {
                                                        this.formModel.slug = this.$utils.createCode(val);
                                                    }
                                                }, deep: true
                                            },
                                        },
                                        methods: {
                                            openIndex() {
                                                window.location.href = "/#/post/index"
                                            },
                                            async openPreview(){
                                                this.showFormView = true;
                                                if(this.formModel.thumbnail){
                                                    let id = this.formModel.thumbnail;
                                                    if (id) {
                                                        this.loading = true;
                                                        await this.$service.get(`media/get`, {
                                                            params: {id: id}
                                                        }).then(response => {
                                                            this.files = [];
                                                            console.log(response);
                                                            this.files[id] = response.data.url;
                                                        }).finally(() => {
                                                            this.loading = false;
                                                        });
                                                    } else {
                                                        this.files = [];
                                                    }
                                                }
                                                console.log(this.files);
                                            },
                                            typeChange() {
                                                this.formModel.fullname = null;
                                            },
                                            save: function (evt) {
                                                if (evt) {
                                                    evt.preventDefault();
                                                }
                                                this.saveLoading = true;
                                                let method = 'post';
                                                let url = this.service;
                                                if (this.formModel.id) {
                                                    method = 'put';
                                                    url += `/update?id=${this.formModel.id}`;
                                                } else {
                                                    method = 'post';
                                                    url += '/create';
                                                }
                                                if (this.beforeSave) {
                                                    this.beforeSave();
                                                }
                                                return this.$service({url: url, method: method, data: this.formModel}).then(response => {
                                                    this.showForm = false;

                                                    if (response.data) {
                                                        this.$swal({
                                                            title: "Thành công",
                                                            text: this.formModel.id ? 'Chỉnh sửa thành công' : 'Thêm mới thành công',
                                                            icon: 'success',
                                                            toast: true,
                                                            position: 'bottom-end',
                                                            timer: 5000,
                                                        });
                                                    } else {
                                                        this.$swal({
                                                            title: "Có lỗi",
                                                            text: this.formModel.id ? 'Chỉnh sửa thất bại' : 'Thêm mới thất bại',
                                                            icon: 'error',
                                                            toast: true,
                                                            position: 'bottom-end',
                                                            timer: 5000,
                                                        });
                                                    }
                                                    this.$router.push('/post/index');
                                                    return response.data;
                                                }).catch(error => {
                                                    if (error.response.data.message) {
                                                        this.$swal({
                                                            text: error.response.data.message,
                                                            icon: 'error'
                                                        });
                                                        this.showForm = false;
                                                    } else {
                                                        this.formErrors = error.response.data;
                                                    }
                                                }).finally(() => {
                                                    this.saveLoading = false;
                                                });
                                            },
                                        },
                                        mounted: function () {
                                            if (this.id) {
                                                this.$service.get(`${this.service}/get?id=${this.id}`).then(response => {
                                                    this.formModel = response.data;

                                                    if (!this.permissions('post_approved') && this.formModel.status != 'private') {
                                                        window.location.href = "/#/post/index"
                                                    }

                                                }).finally(() => {
                                                    this.firstLoading = false;
                                                });
                                            } else {
                                                this.formModel = Object.assign({}, this.defaultFormModel);
                                                this.formErrors = {};
                                                this.showForm = true;
                                                this.firstLoading = false;
                                            }
                                        },
                                    }
                                </script>